import React from "react";
import {Box} from '@mui/material';

export type Source = {
    lg: string;
    md: string;
    sm: string;
}

const WEBP_TYPE = "image/webp";

const detectMimeType = (image: string): string => {
    const format = String(image.split('.').at(-1))
    return `image/${format}`;
};
const Sources = ({source}: {source: Source}) => (
    <>
        <source 
            media="(max-width: 768px)"
            srcSet={source.sm}
            type={detectMimeType(source.sm)}
        />
        <source 
            media="(max-width: 1024px)"
            srcSet={source.md}
            type={detectMimeType(source.md)}
        />
        <source 
            media="(min-width: 1025px)"
            srcSet={source.lg}
            type={detectMimeType(source.lg)}
        />
    </>
);

//@ts-expect-error
const View = ({image, ...rest}) =>  {
    return (
        <Box component='picture'>
            <Sources source={image.webp}/>
            <Sources source={image.original}/>
            <Box component='img'
                src={image.original.lg}
                sx={{maxWidth: '100%'}}
                sizes="(max-width: 1024px) 1024px,
                (max-width: 768px) 768px"
                {...rest}
            />
        </Box>
    )
}


export default View;